import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '@fry/lib/auth';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { LoaderLoadingState, LoaderReadyState, LoaderState } from '@fry/components/common/loader';
import { ClusterOrganisation, ClusterService } from '@fry-it/risr-core';


@Component({
    selector: 'app-set-organisation',
    templateUrl: './set-organisation.component.html',
    styleUrls: ['./set-organisation.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SetOrganisationComponent implements OnInit {
  private return = '/';
  public organisations: ClusterOrganisation[] = [];
  public loadingState: LoaderState = LoaderLoadingState;
  private cluster = inject(ClusterService);

  constructor(
    public auth: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const availableOrgs = this.cluster.getOrganisations();
    of(availableOrgs).pipe(
      map(availableOrgs => {
        const orgs = Object.values(availableOrgs);

        this.loadingState = LoaderReadyState;
        if (orgs.length === 1) {
          this.setOrganisation(orgs[0].id);
          return [];
        }
        return orgs;
      }),
      catchError(err => {
        this.loadingState = { state: 'error', error: err };
        return of([]);
      })
    ).subscribe(orgs => this.organisations = orgs);

    this.route.queryParams.subscribe(params => {
      this.return = params['return'] || '/';
    });
  }

  setOrganisation(orgId: string) {
    this.auth.organisation = orgId;
    this.router.navigate([this.return], { queryParams: {} });
  }
}
